"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoldByValue = exports.SoldByLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const themed_text_1 = require("../themed-text");
exports.SoldByLabel = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    margin-right: ${(props) => props.theme.spacings.small};
    color: ${(props) => props.theme.palettes.font.secondary};
  }
`;
exports.SoldByValue = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  && {
    color: ${(props) => props.theme.palettes.font.base};
  }
`;
